<template>
  <div>
    <formCommon ref="formCommon"
                :form-array="formArray"
                :rules="rules"
                @getData="getData" />
  </div>
</template>

<script>
import formCommon from '@/components/form/formCommon.vue';
import { getAllPlaces } from '@/api/place';
import { createProject, queryDetail, updateProject } from '@/api/project';

export default {
  components: { formCommon },
  data() {
    return {
      formArray: [
        {
          label: '项目名称',
          props: 'name',
          type: 'input',
        },
        {
          label: '客户',
          props: 'site_id',
          type: 'cascader',
        },
        {
          label: '场',
          props: 'place_id',
          type: 'select',
          list: [],
          id: 'id',
          name: 'name',
        },
        {
          label: '产品类型',
          props: 'product',
          type: 'select',
          list: [{
            id: 'TrafficFull',
            name: 'TrafficFull',
          }, {
            id: 'TrafficLite',
            name: 'TrafficLite',
          }, {
            id: 'ParkingLot',
            name: 'ParkingLot',
          }],
          id: 'id',
          name: 'name',
        },
        {
          label: '类型',
          props: 'solution',
          type: 'select',
          list: [{
            id: 'Mall',
            name: 'Mall',
          }, {
            id: 'Store',
            name: 'Store',
          }, {
            id: 'ParkingLot',
            name: 'ParkingLot',
          }, {
            id: 'Navigation',
            name: 'Navigation',
          }],
          id: 'id',
          name: 'name',
        },
        {
          label: '备注',
          props: 'remarks',
          type: 'textarea',
        },
      ],
      rules: {
        name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        site_id: [{ required: true, message: '请输入客户', trigger: 'blur' }],
        place_id: [{ required: true, message: '请选择场', trigger: 'change' }],
        product: [{ required: true, message: '请选择产品类型', trigger: 'change' }],
        solution: [{ required: true, message: '请选择类型', trigger: 'change' }],
      },
    };
  },
  created() {
    this.getAllPlaces();
  },
  mounted() {
    if (this.$route.query.id) this.queryDetail();
  },
  methods: {
    getData(val) {
      if (this.$route.query.id) {
        updateProject(val).then(() => {
          this.$message({
            message: '修改成功',
            type: 'success',
          });
          this.$router.push({ path: '/project' });
        });
      } else {
        createProject(val).then(() => {
          this.$message({
            message: '创建成功',
            type: 'success',
          });
          this.$router.push({ path: '/project' });
        });
      }
    },
    async getAllPlaces() {
      const { data } = await getAllPlaces({});
      this.formArray[2].list = data;
    },
    queryDetail() {
      queryDetail({ id: this.$route.query.id }).then((res) => {
        this.$refs.formCommon.formLabelAlign = res.data;
      });
    },
  },
};
</script>
<style lang="less" scoped></style>
